<div class="right-side-bar-heading">
    HOW TO
</div>

<!-- TODO Get rid of the hard-coded height & width. -->
<div class="right-side-bar-content">
    <ul>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/CIIyHg', 'caNanoLabFAQ', 800, 800)">How do I obtain a new caNanoLab Login ID and Password?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/DYIyHg', 'caNanoLabFAQ', 800, 800)">How do I reset my current caNanoLab password?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/0oEyHg', 'caNanoLabFAQ', 800, 800)">How do I save data to caNanoLab?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/TYFDHg', 'caNanoProtocols', 800, 800)">How do I find nanotechnology protocols?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/loFDHg', 'caNanoPublications', 800, 800)">How do I find nanotechnology publications?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/ioS8HQ', 'caNanoSearch', 800, 800)">How can I search for nanomaterials, composition annotations, and characterizations? </a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/eoQfEQ', 'caNanoAddCharacterizations', 800, 800)">How can I add nanomaterial characterizations? </a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/yoEyHg', 'caNanoLabFAQ', 800, 800)">Where can I get definitions for nanotechnology concepts?</a>
        </li>
        <li>
            <a href="" (click)="openWindow('https://wiki.nci.nih.gov/x/zIEyHg', 'caNanoLabFAQ', 800, 800)">How do I incorporate caNanoLab into a data sharing plan?</a>
        </li>
    </ul>

</div>
